const PRODUCT_DATA: Record<string, { name: string; shortName: string; description: string; heroBgUrl: string; benefits: { icon: string; title: string; desc: string }[] }> = {
  carports: {
    name: 'Навесы для автомобилей (машин)',
    shortName: 'навес для автомобиля (машин)',
    description: 'Защита от снега, дождя, града, солнца и наледи. Надёжная конструкция, которая прослужит десятилетиями. Изготавливаем по индивидуальным размерам с выездом на замер.',
    heroBgUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/429292f1-2c2f-4db4-8b1a-3d69a79edf2b_compressed_IMG_0729.webp',
    benefits: [
      { icon: 'ri-ruler-line', title: 'По вашим размерам', desc: 'Изготовим навес точно под размеры вашего участка и автомобиля' },
      { icon: 'ri-building-2-line', title: 'Собственное производство', desc: 'Свой цех, контроль качества на каждом этапе — от металла до покраски' },
      { icon: 'ri-tools-line', title: 'Монтаж под ключ', desc: 'Привозим, собираем, закрепляем — вы принимаете готовый навес' },
    ],
  },
  canopies: {
    name: 'Козырьки',
    shortName: 'козырёк',
    description: 'Защита крыльца и входной зоны от осадков. Стильное решение, которое дополнит архитектуру вашего дома. Прочный металлический каркас, любой цвет и форма.',
    heroBgUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/6d003a34-d8ea-4b86-9c00-84829ed07f95_compressed_photo_2026-07-27-18.06.43.webp',
    benefits: [
      { icon: 'ri-shield-line', title: 'Защита входа', desc: 'Надёжно защищает крыльцо от дождя, снега и наледи круглый год' },
      { icon: 'ri-palette-line', title: 'Любой дизайн', desc: 'Подберём цвет и форму под архитектуру вашего дома' },
      { icon: 'ri-tools-line', title: 'Монтаж за день', desc: 'Привозим готовую конструкцию, устанавливаем за 1–2 дня' },
    ],
  },
  gazebos: {
    name: 'Беседки',
    shortName: 'беседка',
    description: 'Готовая зона отдыха на участке, защищённая от солнца и осадков. Стиль под архитектуру дома, металл в сочетании с деревом и стеклом.',
    heroBgUrl: 'https://readdy.ai/api/search-image?query=Elegant%20metal%20frame%20gazebo%20with%20wooden%20accents%20and%20glass%20panels%20in%20a%20lush%20green%20garden%20of%20a%20private%20house%20warm%20evening%20golden%20hour%20lighting%20cozy%20inviting%20atmosphere%20family%20gathering%20space%20protected%20from%20sun%20and%20rain%20architectural%20photography%20wide%20angle%20realistic%20high%20quality&width=1800&height=1200&seq=gazebos-hero-bg&orientation=landscape',
    benefits: [
      { icon: 'ri-home-smile-line', title: 'Уютное место', desc: 'Создаём пространство для отдыха всей семьёй в любую погоду' },
      { icon: 'ri-building-2-line', title: 'Индивидуальный проект', desc: 'Учитываем размер участка, стиль дома и ваши пожелания' },
      { icon: 'ri-tools-line', title: 'Монтаж под ключ', desc: 'Привозим, собираем, закрепляем — вы принимаете готовую беседку' },
    ],
  },
  gates: {
    name: 'Ворота и калитки',
    shortName: 'ворота',
    description: 'Откатные и распашные ворота, калитки с коваными элементами. Надёжная защита участка с эстетикой художественной ковки.',
    heroBgUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/9cfe3f66-baa4-4ee6-825b-cb23f51b99ba_compressed_IMG_0825.webp',
    benefits: [
      { icon: 'ri-shield-flash-line', title: 'Надёжная защита', desc: 'Прочный металл, усиленные петли и замки — участок под охраной' },
      { icon: 'ri-settings-3-line', title: 'Автоматика', desc: 'Установим электропривод — ворота открываются с пульта' },
      { icon: 'ri-tools-line', title: 'Монтаж под ключ', desc: 'Привозим, устанавливаем, настраиваем автоматику — всё включено' },
    ],
  },
  bbq: {
    name: 'Мангальные зоны',
    shortName: 'мангальная зона',
    description: 'Полноценная зона для приготовления на огне — мангал, казан, коптильня под навесом. Всё в едином стиле из металла.',
    heroBgUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20barbecue%20area%20with%20metal%20roof%20canopy%20brick%20grill%20simple%20practical%20design%20garden%20setting%20daytime%20natural%20lighting%20casual%20realistic%20photography%20ordinary%20backyard&width=1800&height=1200&seq=bbq-hero-bg&orientation=landscape',
    benefits: [
      { icon: 'ri-fire-line', title: 'Всё для огня', desc: 'Мангал, казан, коптильня — делаем полный комплекс' },
      { icon: 'ri-umbrella-line', title: 'С навесом', desc: 'Защита от дождя и солнца — готовьте в любую погоду' },
      { icon: 'ri-tools-line', title: 'Монтаж под ключ', desc: 'От фундамента до финишной отделки — всё делаем сами' },
    ],
  },
  'grave-fences': {
    name: 'Кованые оградки',
    shortName: 'оградка',
    description: 'Кованые оградки для могил по индивидуальным эскизам. Достойное оформление, качественный металл и покраска.',
    heroBgUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/cc9320d2-107b-4b84-8123-4f291fb5abb0_compressed_DSC01194.webp',
    benefits: [
      { icon: 'ri-heart-line', title: 'С уважением', desc: 'Понимаем важность момента, делаем достойно и аккуратно' },
      { icon: 'ri-pencil-ruler-line', title: 'По эскизу', desc: 'Изготовим по вашему эскизу или поможем с дизайном' },
      { icon: 'ri-tools-line', title: 'Монтаж', desc: 'Привозим и устанавливаем на месте — вам не нужно ничего делать' },
    ],
  },
  railings: {
    name: 'Перила и ограждения',
    shortName: 'перила',
    description: 'Кованые перила для крыльца, лестниц и балконов. Надёжные, красивые, с элементами художественной ковки.',
    heroBgUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/411cb964-6df6-4532-ad9e-58e573066d9b_compressed_SSA57590.webp',
    benefits: [
      { icon: 'ri-shield-check-line', title: 'Безопасность', desc: 'Надёжные сварные соединения, устойчивая конструкция' },
      { icon: 'ri-brush-line', title: 'Красота', desc: 'Элементы художественной ковки украсят ваш дом' },
      { icon: 'ri-tools-line', title: 'Монтаж', desc: 'Привозим, устанавливаем, закрепляем — готовые перила за день' },
    ],
  },
  'fireplace-sets': {
    name: 'Каминные наборы',
    shortName: 'каминный набор',
    description: 'Кованые наборы для камина: кочерга, совок, щипцы, подставка. Функционально и стильно, ручная работа.',
    heroBgUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/861113ac-a618-44f3-972b-e5806b569b22_compressed_DSC09273.webp',
    benefits: [
      { icon: 'ri-fire-line', title: 'Для уюта', desc: 'Красивый набор у камина создаёт атмосферу тепла и уюта' },
      { icon: 'ri-paint-brush-line', title: 'Ручная работа', desc: 'Каждый элемент выкован вручную — нет двух одинаковых наборов' },
      { icon: 'ri-gift-line', title: 'Отличный подарок', desc: 'Универсальный подарок для владельцев каминов и печей' },
    ],
  },
  'wrought-furniture': {
    name: 'Кованая мебель',
    shortName: 'кованая мебель',
    description: 'Столы, стулья, скамейки, кровати из кованого металла. Прочная, стильная мебель для дома и сада.',
    heroBgUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/8db1a512-0dd6-4b23-9fda-3dd8a98941a4_compressed_IMG_0131.webp',
    benefits: [
      { icon: 'ri-vip-crown-line', title: 'Эксклюзив', desc: 'Уникальная мебель, которой нет больше ни у кого' },
      { icon: 'ri-shield-check-line', title: 'На века', desc: 'Металл служит десятилетиями, не теряя внешнего вида' },
      { icon: 'ri-home-line', title: 'Дом и сад', desc: 'Делаем мебель для интерьера и уличную — с защитным покрытием' },
    ],
  },
  'window-grilles': {
    name: 'Решётки для окон',
    shortName: 'решётка',
    description: 'Защитные и декоративные решётки на окна. Надёжная защита от взлома с эстетикой кованого узора.',
    heroBgUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/f2fc6511-aea8-4de6-ab97-4501581c7feb_compressed_DSC01345.webp',
    benefits: [
      { icon: 'ri-shield-flash-line', title: 'Защита', desc: 'Надёжная преграда для злоумышленников — сталь не перекусить' },
      { icon: 'ri-eye-line', title: 'Эстетика', desc: 'Красивый кованый узор не портит вид дома, а украшает его' },
      { icon: 'ri-tools-line', title: 'Монтаж', desc: 'Изготовим по размерам окон, привезём и установим' },
    ],
  },
  swings: {
    name: 'Качели',
    shortName: 'качели',
    description: 'Кованые садовые качели для детей и взрослых. Надёжные, красивые, с мягкими сиденьями и навесом.',
    heroBgUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/5a72c1d8-20bd-41f0-9c28-c02e21b58c0a_compressed_IMG_0425.webp',
    benefits: [
      { icon: 'ri-heart-pulse-line', title: 'Радость', desc: 'Любимое место отдыха для всей семьи — от детей до бабушек' },
      { icon: 'ri-umbrella-line', title: 'С навесом', desc: 'Защита от солнца — можно качаться даже в полдень' },
      { icon: 'ri-tools-line', title: 'Монтаж', desc: 'Привозим, собираем, закрепляем — качели готовы к использованию' },
    ],
  },
  benches: {
    name: 'Скамейки',
    shortName: 'скамейка',
    description: 'Кованые скамейки для сада, парка и улицы. Прочный металл, деревянное сиденье, стильный дизайн.',
    heroBgUrl: 'https://storage.readdy-site.link/project_files/14f2ab06-cd48-4cfe-a53b-3e34e624542c/9620df55-5e60-46ce-aa1e-6745ba0eddaa_compressed_SSA57690.webp',
    benefits: [
      { icon: 'ri-tree-line', title: 'Для сада', desc: 'Идеально вписывается в ландшафт — стильно и функционально' },
      { icon: 'ri-shield-check-line', title: 'Антивандальные', desc: 'Прочный металл, устойчивое покрытие — прослужат десятилетия' },
      { icon: 'ri-tools-line', title: 'Монтаж', desc: 'Привозим и устанавливаем — можно бетонировать или просто поставить' },
    ],
  },
};

const CITY_DATA: Record<string, { name: string; prepositional: string }> = {
  belebey: { name: 'Белебей', prepositional: 'в Белебее' },
  ermekeevo: { name: 'Ермекеево', prepositional: 'в Ермекеево' },
  bizhbulyak: { name: 'Бижбуляк', prepositional: 'в Бижбуляке' },
  abdulino: { name: 'Абдулино', prepositional: 'в Абдулино' },
  ponomarevka: { name: 'Пономарёвка', prepositional: 'в Пономарёвке' },
  matveevka: { name: 'Матвеевка', prepositional: 'в Матвеевке' },
  novomikhailovka: { name: 'Новомихайловка', prepositional: 'в Новомихайловке' },
  bavly: { name: 'Бавлы', prepositional: 'в Бавлах' },
  buguruslan: { name: 'Бугуруслан', prepositional: 'в Бугуруслане' },
  'kirgiz-miyaki': { name: 'Киргиз-Мияки', prepositional: 'в Киргиз-Мияках' },
  tuymazy: { name: 'Туймазы', prepositional: 'в Туймазах' },
  oktyabrsky: { name: 'Октябрьский', prepositional: 'в Октябрьском' },
  buzdyak: { name: 'Буздяк', prepositional: 'в Буздяке' },
  kandry: { name: 'Кандры', prepositional: 'в Кандрах' },
  davlekanovo: { name: 'Давлеканово', prepositional: 'в Давлеканово' },
  raevka: { name: 'Раевка', prepositional: 'в Раевке' },
  ufa: { name: 'Уфа', prepositional: 'в Уфе' },
  chishmy: { name: 'Чишмы', prepositional: 'в Чишмах' },
};

const ALL_CITIES = Object.keys(CITY_DATA).map((slug) => CITY_DATA[slug]);
const ALL_PRODUCTS = Object.keys(PRODUCT_DATA).map((slug) => ({ slug, ...PRODUCT_DATA[slug] }));

export { PRODUCT_DATA, CITY_DATA, ALL_CITIES, ALL_PRODUCTS };